import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import path from '../../helpers/path';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import ProductIconContainer from 'apex-web/lib/components/common/ProductIcon/ProductIconContainer';
import CryptoNavItemsContainer from 'apex-web/lib/components/WalletNavItems/CryptoNavItemsContainer';
import APIcon from 'apex-web/lib/components/common/APIcon';
import FiatNavItemsContainer from 'apex-web/lib/components/WalletNavItems/FiatNavItemsContainer';

import 'apex-web/lib/components/WalletRows/WalletRow.css';

const walletRowClasses = getBEMClasses('wallet-row');

const WalletRow = (props, context) => {
  const {
    iconFileName,
    ProductSymbol,
    ProductFullName,
    isCrypto,
    ProductId,
    width,
    detailsLink,
    isWithdrawAllowed,
    isDepositAllowed
  } = props;
  const replaceActivityLink = width < 768 ? true : false;
  const iconSize = width > 1024 ? 44 : 28;

  const renderActivityLink = () => {
    return (
      <div className={walletRowClasses('activity-link')}>
        <Link
          className={walletRowClasses('activity-link')}
          to={path(detailsLink)}
          onClick={props.selectPositionAndSave}>
          {context.t('Details')}{' '}
          <APIcon
            name="arrowNext"
            customClass={walletRowClasses('next-icon')}
          />
        </Link>
      </div>
    );
  };

  return (
    <div className={walletRowClasses()}>
      <div className={walletRowClasses('icon-label')}>
        <div className={walletRowClasses('product-icon')}>
          <ProductIconContainer iconFileName={iconFileName} size={iconSize} />
        </div>
        <div className={walletRowClasses('symbol-label')}>
          {`${ProductSymbol} ${ProductFullName}`}
          {replaceActivityLink && renderActivityLink()}
        </div>
      </div>
      <div className={walletRowClasses('activity-link-columns')}>
        {!replaceActivityLink && renderActivityLink()}
        <div className={walletRowClasses('icon-nav-buttons')}>
          {isCrypto ? (
            <CryptoNavItemsContainer
              product={{
                iconFileName,
                ProductSymbol,
                ProductFullName,
                ProductId,
                isWithdrawAllowed,
                isDepositAllowed
              }}
              showIconButtonLabel={false}
            />
          ) : (
            <FiatNavItemsContainer
              product={{
                iconFileName,
                ProductSymbol,
                ProductFullName,
                ProductId,
                isWithdrawAllowed,
                isDepositAllowed
              }}
              showIconButtonLabel={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

WalletRow.contextTypes = {
  t: PropTypes.func.isRequired
};

export default WalletRow;
